import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const gsapStaggerFade = () => {

  const selectors = ['.farmstand-issues-grid__entries', '.farmstand-statistics__entries']

  if (!Array.isArray(selectors) || !selectors.length) return;

  const containers = document.querySelectorAll(selectors.join(", "));
  if (!containers.length) return;

  containers.forEach((container) => {
    const children = container.children;
    if (!children.length) return;

    gsap.set(children, { opacity: 0, y: 20 });

    ScrollTrigger.create({
      trigger: container,
      start: "top 75%",
      onEnter: () => {
        gsap.to(children, {
          opacity: 1,
          y: 0,
          stagger: 0.1,
          duration: 0.6,
          ease: "power2.out",
        });
      },
      onLeaveBack: () => {
        gsap.set(children, { opacity: 0, y: 20 });
      },
    });
  });
};

export { gsapStaggerFade };
